import React, { useState } from 'react';
import { AttachmentRow } from '@/components/AttachmentRow';
import { AttachmentPreview } from '@/components/AttachmentPreview';
import type { Attachment } from '@/types/attachment';
import type { TextWithAttachments } from '@/types/diary';
import { sanitizeRichTextHtml } from '@/utils/html';

interface Props {
  content: TextWithAttachments;
}

export const PlanHtmlCard: React.FC<Props> = ({ content }) => {
  const [previewAttachment, setPreviewAttachment] = useState<Attachment | null>(
    null,
  );

  return (
    <div className="flex flex-col gap-6 rounded-xl bg-card p-4 shadow-card contrast:border contrast:border-border">
      {!!content.text && (
        <div
          className="rich-text text-body-14 text-muted-foreground"
          dangerouslySetInnerHTML={{
            __html: sanitizeRichTextHtml(content.text),
          }}
        />
      )}

      {!!content.attachments.length && (
        <div className="flex flex-wrap gap-6">
          {content.attachments.map((attachment) => (
            <AttachmentRow
              key={attachment.id}
              attachment={attachment}
              className="w-fit max-w-full md:max-w-[200px]"
              onPreview={setPreviewAttachment}
            />
          ))}
        </div>
      )}

      {previewAttachment && (
        <AttachmentPreview
          attachment={previewAttachment}
          onClose={() => setPreviewAttachment(null)}
          onDownloaded={() => setPreviewAttachment(null)}
        />
      )}
    </div>
  );
};
